import { inlines } from './inlines';
export var paragraph = function paragraph(node) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    context = _ref.context;
  var result = '';
  node.forEach(function (n) {
    result += inlines(n, {
      context: context
    });
  });
  return result;
};